import { ExternalLink } from 'lucide-react'

import { Card, CardContent } from '@/modules/shared/components/ui/card'
import { cn } from '@/modules/shared/lib/utils'
import type { Entity } from '@/modules/shared/types/entity.type'
import { formatCnpjCpf } from '../helpers/format-fields-customer-form.helper'

type CustomerCardComponentProps = {
	entity: Entity
	clientSelected: Entity
	onSelectEntity: (entity: Entity) => void
	handleStartView: (clientId?: string) => void
}

export function CustomerCardComponent({
	clientSelected,
	entity,
	onSelectEntity,
	handleStartView,
}: CustomerCardComponentProps) {
	return (
		<div
			onKeyUp={(e) => {
				if (e.key === 'Enter') {
					handleStartView(entity.idEntidade.toString())
				}
			}}
			key={entity?.idEntidade}
			className="min-h-full"
			onClick={() =>
				clientSelected && clientSelected.idEntidade === entity.idEntidade
					? onSelectEntity(null)
					: onSelectEntity(entity)
			}
			style={{ cursor: 'pointer' }}
		>
			<Card
				key={entity?.idEntidade}
				className={cn(
					'cursor-pointer relative',
					clientSelected?.idEntidade === entity.idEntidade && ' bg-sky-500/30',
				)}
			>
				<CardContent className="p-4 text-sm flex-1 flex flex-col md:min-h-32 mr-8">
					<div className="flex  items-center lex-1 h-full">
						<p className="font-semibold  flex-1">
							{entity?.idEntidade} - {entity?.razaoSocialNome}
						</p>
					</div>

					<p>{formatCnpjCpf(entity?.cnpjCpf)}</p>
					<span className="line-clamp-3 text-xs">
						{entity.logradouro}, {entity.numero}
						{entity.bairro && `, ${entity.bairro}`}
					</span>
				</CardContent>
				<div
					onKeyUp={(e) => {
						if (e.key === 'Enter') {
							handleStartView(entity.idEntidade.toString())
						}
					}}
					onClick={(e) => {
						e.stopPropagation()
						handleStartView(entity.idEntidade.toString())
					}}
					className={cn(
						' absolute top-0 right-0  p-2 md:p-2 rounded-r-md h-full  bg-gray-200/30',
						clientSelected?.idEntidade === entity.idEntidade && 'bg-sky-500/30',
					)}
				>
					<ExternalLink className="text-gray-600 ml-1" size={16} />
				</div>
			</Card>
		</div>
	)
}
